import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function EXHome() {
  const navigate = useNavigate();

  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(true);
  const apiMode = 'normal'; // set to 'transfer' to use /api/9wkt/join instead

  // Step 1: Fetch logo first
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!response.ok) throw new Error("Failed to fetch logo");
        const data = await response.json();
        setLogo(data[0]?.logo || null);
      } catch (error) {
        console.error("Error fetching logo:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchLogo();
  }, []);

  // Step 2: Call iframe API only after logo loaded
  useEffect(() => {
    if (loading || !logo) return;

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const remote_id = localStorage.getItem("remote_id");

        const url = apiMode === 'transfer'
          ? `${process.env.REACT_APP_API_URL}/api/9wkt/join`
          : `${process.env.REACT_APP_API_URL}/api/iframe/play`;

        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({
            id: "eg_" + remote_id,
            token: token,
            providerSitePage: window.location.origin,
            origin: window.location.origin,
            siteLogo: `${process.env.REACT_APP_API_URL}/storage/${logo}`,
          }),
        });

        const dataly = await response.json();
        const iframeUrl = dataly?.data?.launch?.data?.launchUrl ?? dataly?.game_url;

        if (!iframeUrl) throw new Error("Invalid iframe launch response");

        if (iframeUrl.match(/mcwbd/i) || dataly?.data?.fullRedir || iframeUrl.includes('#/9wkt')) {
          window.location.href = iframeUrl;
          return;
        }

        navigate("/gamerun", { state: { iframeUrl, apiMode } });
      } catch (error) {
        console.error("Error fetching player login:", error);
      }
    };

    fetchData();
  }, [logo, loading, navigate]);

  return null;
}

export default EXHome;
